module.exports = __webpack_public_path__ + "media/img/wundervisuals_1355666-a778db64.jpg";